/* eslint-disable sonarjs/no-duplicate-string */
import {
  IncomingMyReviewAppraisalCycle,
  IncomingMyReviewAppraisalForm,
  IncomingMyReviewEmployeeDetails,
  MyReviewModalProps,
  PageDetails,
} from '../../../types/Performance/MyReview/myReviewTypes'

export const initialPageDetails: PageDetails = {
  country: null,
  departmentId: null,
  departmentName: null,
  description: '',
  displayOrder: 0,
  empCountry: '',
  handCountry: [],
  id: 0,
  pageName: '',
  sectionId: null,
  sectionName: null,
  title: '',
  type: '',
}

export const initialIncomingMyReviewAppraisalCycle: IncomingMyReviewAppraisalCycle =
  {
    id: -1,
    name: '',
    description: null,
    toDate: '',
    fromDate: '',
    active: false,
    appraisalType: '',
    appraisalDuration: '',
    level: -1,
    cycleStartedFlag: false,
    appraisalStartDate: '',
    appraisalEndDate: '',
    servicePeriod: -1,
  }

export const initialMyReviewModal: MyReviewModalProps = {
  showModal: false,
  description: '',
  confirmBtnText: 'Confirm',
  cancelBtnText: 'Cancel',
  confirmBtnAction: undefined,
  modalHeaderClass: 'd-none',
  modalFooterClass: undefined,
  modalSize: undefined,
}

export const initialMyReviewEmployeeDetials: IncomingMyReviewEmployeeDetails = {
  id: -1,
  firstName: null,
  lastName: null,
  middleName: null,
  designation: '',
  role: null,
  manager: null,
  designationKrasDTO: null,
  employeeSubmitted: null,
  managerSubmitted: null,
  acknowledged: null,
  fullName: '',
  profilePicPath: '',
  thumbPicture: '',
  profilePicGeneratedPath: null,
  gender: null,
  dob: null,
  departmentName: '',
  employmentTypeName: null,
  jobTypeName: null,
  imageData: null,
  curentLocation: null,
  baseLocation: null,
  officialBirthday: null,
  realBirthday: null,
  maritalStatus: null,
  emergencyContactName: null,
  emergencyPhone: null,
  emergencyRelationShip: null,
  grade: null,
  aboutMe: null,
  homeNumber: null,
  workNumber: null,
  presentAddress: null,
  presentCity: null,
  presentZip: null,
  presentLandMark: null,
  permanentAddress: null,
  permanentCity: null,
  permanentZip: null,
  permanentLandMark: null,
  mobile: null,
  homeCode: null,
  workCode: null,
  skillList: null,
  userName: null,
  alternativeMobile: null,
  dateOfJoining: null,
  informationList: null,
  anniversary: null,
  bankInformationList: null,
  bioAttendanceDtoSet: null,
  dates: null,
  absentCount: 0,
  statusName: null,
  emergencyContact: null,
  relievingDate: null,
  observationDTOList: null,
  skypeId: null,
  percent: null,
  passportNumber: null,
  passportExpDate: null,
  passportIssuedPlace: null,
  passportIssuedDate: null,
  token: null,
  underNoticeDate: null,
  candidateId: null,
  underNotice: null,
  emailId: '',
  empManager: '',
  bloodgroup: null,
  rbtCvPath: null,
  rbtCvName: null,
  timeSlotDTO: null,
  technology: null,
  hrAssociate: null,
  lateComingCount: null,
  passportFrontPagePath: null,
  passportBackPagePath: null,
  passportFrontPage: null,
  passportBackPage: null,
  projectManager: null,
  casualLeaveCount: 0,
  lopLeaveCount: 0,
  holidaysCount: 0,
  contractExists: null,
  contractStartDate: null,
  contractEndDate: null,
  personalEmail: null,
  experience: null,
  companyExperience: null,
  updatedExperience: null,
  country: null,
  workStatus: null,
  comments: null,
  vendorId: null,
  vendorName: null,
  countryCodeWork: null,
  countryCodeMobile: null,
  countryCodeHome: null,
  countryCodeEmergency: null,
  countryCodeAlternative: null,
  address: null,
}

export const initialAppraisalForm: IncomingMyReviewAppraisalForm = {
  id: -1,
  appraisalCycle: initialIncomingMyReviewAppraisalCycle,
  kra: [],
  employee: initialMyReviewEmployeeDetials,
  formStatus: '',
  formStatusvalue: 0,
  formRating: null,
  appraisalFormStatus: null,
  adjustedAvgRating: null,
  finalFeedback: null,
  avgRatingsDtos: [],
  overallAvgRating: '',
  overallAvgRatingName: null,
  finalRating: null,
  finalRatingName: null,
  discussionOn: null,
  discussionSummary: null,
  openForDiscussionFlag: null,
  iAgreeFlag: null,
  closedSummary: null,
  closedOn: null,
  pendingWith: null,
  closedStatus: null,
  closedBy: null,
  empDepartmentName: null,
  empDesignationName: null,
  empAvgRating: null,
  empAvgRatingName: null,
  manager1Name: null,
  requestDiscussion: false,
  kpis: null,
}
